import loadable from '@loadable/component';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { NodeViewRendererProps, NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

const LinkPreviewRenderer: FC<NodeViewRendererProps> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}: NodeViewRendererProps) => {
  const LinkPreview = useMemo(
    () =>
      loadable(() => import(/* webpackChunkName: "ricos_plugin_linkPreview" */ './linkPreview')),
    []
  );
  return (
    <LinkPreview
      key={node.id}
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      {...props}
    />
  );
};

const LinkPreviewLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <LinkPreviewRenderer key={node.id} node={node} {...props} />;
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.LINK_PREVIEW]: LinkPreviewLoadable,
  [Node_Type.EMBED]: LinkPreviewLoadable,
};
